module.exports = __webpack_public_path__ + "static/media/nyugta_minta.5bab66ea.jpg";